import { IEventTicket, TicketSortMode } from '../../../../../../surveys/models/Api';

/**
 * Preview-only: mirrors the backend's tier ordering since the preview has no server round-trip.
 * Stable, so tiers that tie on the sort key keep their authored order.
 */
export function sortEventTicketsForDisplay(
	tickets: IEventTicket[],
	sortMode: TicketSortMode = TicketSortMode.PriceAscending
): IEventTicket[] {
	const byName = (a: IEventTicket, b: IEventTicket) =>
		(a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' });

	const sorted = [...tickets];
	switch (sortMode) {
		case TicketSortMode.PriceDescending:
			return sorted.sort((a, b) => (b.unitPrice || 0) - (a.unitPrice || 0));
		case TicketSortMode.NameAscending:
			return sorted.sort(byName);
		case TicketSortMode.NameDescending:
			return sorted.sort((a, b) => byName(b, a));
		default:
			return sorted.sort((a, b) => (a.unitPrice || 0) - (b.unitPrice || 0));
	}
}
